module.exports = __webpack_public_path__ + "static/media/nft-photos-icon1.b6e7a23c.svg";